import React from 'react';
import { connect } from 'react-redux';

// Components
import ResolutionChanger from 'components/edit/ResolutionChanger.js';
import EditBar from 'components/edit/EditBar.js';

// Images
import AppIcon from 'img/layout-icons/gandr-logo-v2.png';

import 'App.css';
import './AppHeader.css';

class AppHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      
    }
  }

  render() {

    let numChosenPhotos = Object.keys(this.props.collage.photos.chosenNodes).length;
    let downloadClass   = ['Button', 'Button--Download'];
    let downloadTitle   = 'Save collage to your device or computer';

    if ( !numChosenPhotos ) {
      downloadClass.push('Button--Disabled');
      downloadTitle = 'Add photos to collage before downloading';
    }

    return (
      <div className="AppHeader MainPadding">
        <div className="Logo">
          <img src={AppIcon} className="AppIcon" alt="Gandr app icon - 2020" />
          <h1>gandr.io</h1>
        </div>

        <a href="mailto:feedback@gandr.io" className="Feedback">feedback@gandr.io</a>

        {(this.props.collage.activeText !== false && this.props.collage.mode != 'sm') &&
          <EditBar />
        }

        <div className="SaveAction">
          <span className="CollageResolution">
            {this.props.collage.resolution.width} x {this.props.collage.resolution.height}&nbsp;&nbsp;
            <button 
              className="Button--TextLink ButtonReset"
              onClick={() => {
                this.setState({resolutionModalOpen: true})
              }}
            >Change</button>
          </span>
          <button 
            className={downloadClass.join(' ')}
            title={downloadTitle}
            onClick={this.props.onDownloadClick}
          >
            Download
          </button>
          <a 
            download={'gandr-collage.jpg'}
            id="export"
            aria-hidden="true"
          ></a>
        </div>
        
        <ResolutionChanger 
          open={this.state.resolutionModalOpen} 
          onCloseClick={() => this.setState({resolutionModalOpen: false})}
        />

      </div>
    );
  }
}

const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  null
)(AppHeader)